import React from 'react';
import PartnerItem from './PartnerItem.jsx';
import TablePagination from 'components/Pagination/TablePagination';
import Headers from './Headers.jsx';

function Partners({
  partners,
  navigateToPartner,
  checkedPartnerIds,
  partner_ids,
  paginationProps,
  onOrderChange,
  query
}) {
  return (
    <table>
      <Headers
        onChange={onOrderChange}
        value={query.order}
      />
      {partners.map(partner => (
        <PartnerItem
          partner={partner}
          key={partner.id}
          navigateToPartner={navigateToPartner}
          checkedPartnerIds={checkedPartnerIds}
          partner_ids={partner_ids}
        />
      ))}
      <tr>
        <td colSpan="12">
          <TablePagination
            {...paginationProps}
          />
        </td>
      </tr>
    </table>
  );
}

Partners.defaultProps = {};

Partners.propTypes = {};

export default Partners;



// WEBPACK FOOTER //
// ./src/components/Admin/Partner/List/index.jsx